import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup,
        size: "small"
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_component_NcButton, {
            onClick: _ctx.add,
            class: "button",
            variant: "secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', 'Add Path')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_NcButton, {
            onClick: _ctx.save,
            class: "button",
            variant: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', 'Save')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (path, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "path"
              }, [
                _createTextVNode(_toDisplayString(path) + " ", 1),
                _createVNode(_component_NcActions, { inline: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NcActionButton, {
                      "aria-label": _ctx.t('memories', 'Remove'),
                      onClick: ($event: any) => (_ctx.remove(index))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CloseIcon, { size: 20 })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Remove')) + " ", 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label", "onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}